import { DynamicModulesConfigMap, DynamicModuleSlug } from '../dynamic-modules.types';
import { initDynamicModule } from '../dynamic-modules.utils';
import { GameRegistryResult } from './game-registry.types';

export const initGameRegistryModule = async (configMap: DynamicModulesConfigMap) =>
  initDynamicModule<GameRegistryResult>(DynamicModuleSlug.GAME_REGISTRY, configMap);
